import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, ButtonToolbar, Button } from 'reactstrap';
import { Field } from 'react-final-form';
import MuiButton from '@material-ui/core/Button';
import SwitchField from '@/shared/components/form/Switch';
import ImportHistoryModal from './ImportHistoryModal';
import Select from "react-select";
import FormCsvField from "./FormCsvField";
import SetupFields from "./SetupFields";
import getCsvImportSettings from '@/service/getCsvImportSettings';
import {withRouter, useParams} from "react-router-dom";
import {connect} from "react-redux";

const FormStep2 = ({ config, onclickBack, importHeaders, isValidResponse, setSaveSettings, saveSettings, handleSubmit, organization, rootPrograms = [], rootProgramId, setRootProgramId, onClickImport, configId }) => {
    const [isHistoryOpen, setHistoryOpen] = useState(false);
    const [checked, setChecked] = useState(false);
    const [savedSettings, setSavedSettings] = useState([]);
    const [typeChanged, setTypeChanged] = useState(false);
    const [customSubmit, setCustomSubmit] = useState(false);
    const switchHandler = () => {
        setChecked(!checked);
    };

    const makeOptions = obj => {
        let newOptions = []
        for (const [key, fields] of Object.entries(obj)) {
            // console.log(key)
            let newOption = {
                label: key,
                options: []
            }
            for (const [name] of Object.entries(fields)) {
                // console.log(name)
                newOption.options.push({ label: name, value: key+name })
            }

            newOptions.push(newOption)
        }
        // console.log(newOptions)
        return newOptions;
    }

    useEffect(() => {
        if(saveSettings){
            handleSubmit();
        }
    }, [saveSettings]);

    useEffect(() => {
        if(customSubmit){
            handleSubmit();
        }
    }, [customSubmit]);

    let { id } = useParams();
    useEffect(() => {
        if (id && organization?.id) {
            getCsvImportSettings(organization.id, id)
                .then(data => {
                    setSavedSettings(data);
                })
        }
    }, [organization]);

    if (!importHeaders || (id && !savedSettings) ) return 'Loading...'
    const fieldsToMap = makeOptions(importHeaders.fieldsToMap);

    return (
        <>
        {configId && (
            <ImportHistoryModal
                isOpen={isHistoryOpen}
                toggle={() => setHistoryOpen(false)}
                organization={organization}
                configId={configId}
            />
        )}
        <div className="form-step2">
            <div className="form__form-group">
                {rootPrograms.length > 0 && setRootProgramId && (
                    <div className="mb-3">
                        <h4>Root Program</h4>
                        <Row className="mt-2">
                            <Col md="4"><h5>Select root program:</h5></Col>
                            <Col md="6">
                                <Select
                                    options={rootPrograms}
                                    isClearable
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    placeholder="— select —"
                                    value={rootPrograms.find(p => p.value === rootProgramId) || null}
                                    onChange={opt => setRootProgramId(opt ? opt.value : null)}
                                />
                            </Col>
                        </Row>
                    </div>
                )}
                {importHeaders.hasOwnProperty("setups") &&
                    <SetupFields setups={importHeaders.setups} setupsFull={importHeaders.setupsFull} setTypeChanged={setTypeChanged}
                                 savedSettings={savedSettings} typeChanged={typeChanged} />
                }
                {importHeaders.hasOwnProperty("Userroles") && <Row>
                    <Col md="3">
                        <h5>User Role</h5>
                    </Col>
                    <Col md="9" lg="7" xl="5" >
                        <Field name={config.userRole.name}>
                            {({ input, meta }) => (
                                <div>
                                    <Select
                                        options={config.userRole.options}
                                        clearable={false}
                                        className="react-select"
                                        placeholder={config.userRole.placeholder}
                                        classNamePrefix="react-select"
                                        {...input}
                                    />
                                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                </div>
                            )}
                        </Field>
                    </Col>
                </Row>}
                {importHeaders.hasOwnProperty("Emailusers") && <Row>
                    <Col md="3">
                        <h5>Email User?</h5>
                    </Col>
                    <Col md="9" lg="7" xl="5" >
                        <Field name="email_user">
                            {({ input, meta }) => (
                                <div>
                                    <SwitchField checked={checked} name={input.name} onClick={switchHandler} />
                                </div>
                            )}
                        </Field>
                    </Col>
                </Row>}
                {isValidResponse(importHeaders) &&
                    <>
                        <Row>
                            <Col md="12"><h4 className='mb-3'>Field Mapping</h4></Col>
                        </Row>
                        {importHeaders.CSVheaders.map((field, index) => <div key={index}><FormCsvField {... { field, fieldsToMap, savedSettings, typeChanged }} /></div>)}
                        <br />
                    </>
                }
                <Field
                  name="isSaveSettings"
                  component="input"
                  type="hidden"
                  placeholder="Last Name"
                  initialValue={saveSettings}
                />
                <div className="form__form-group-field flex-column">
                    <div className="form__form-group-row flex-row pt-3">
                        <Button className="btn btn-outline-primary btn-sm" color="#ffffff" disabled={1 == 2} onClick={onclickBack} style={{}}>Back</Button>
                        <Button onClick={(e) => {
                            e.preventDefault();
                            setSaveSettings(true);
                        }} className="btn btn-primary btn-sm" color="#ffffff" type="submit" style={{}}>Save Settings</Button>
                        {onClickImport && (
                            <Button onClick={(e) => { e.preventDefault(); onClickImport(); }} className="btn btn-success btn-sm" style={{}}>Import</Button>
                        )}
                        {configId && (
                            <Button onClick={(e) => { e.preventDefault(); setHistoryOpen(true); }} className="btn btn-secondary btn-sm ml-1">History</Button>
                        )}
                        {/*{ !id &&*/}
                        {/*    <Button onClick={(e) => {*/}
                        {/*        // e.preventDefault();*/}
                        {/*        setSaveSettings(false);*/}
                        {/*        // setCustomSubmit(true);*/}
                        {/*    }} className="btn btn-primary btn-sm" color="#ffffff" disabled={1 == 2} type="submit" style={{}}>Import</Button>*/}
                        {/*}*/}
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default withRouter(connect((state) => ({
    organization: state.organization
}))(FormStep2));

